// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetSiHaDocumentationRequestModel from '../../model/get-si-ha-documentation-request-model';
import GetSiHaDocumentationRequestDTO from '../dto/get-si-ha-documentation-request-dto';
import dtoSchema from '../schemas/get-si-ha-documentation-request-schema';

export default abstract class GetSiHaDocumentationRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetSiHaDocumentationRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetSiHaDocumentationRequestDTO>): GetSiHaDocumentationRequestModel;
  static toModel(dto: DeepPartial<GetSiHaDocumentationRequestDTO> | undefined | null): GetSiHaDocumentationRequestModel | undefined;
  static toModel(dto: DeepPartial<GetSiHaDocumentationRequestDTO> | undefined | null): GetSiHaDocumentationRequestModel | undefined {
    return dto ? new GetSiHaDocumentationRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetSiHaDocumentationRequestModel> | GetSiHaDocumentationRequestModel): GetSiHaDocumentationRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetSiHaDocumentationRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetSiHaDocumentationRequestModel, can not map to GetSiHaDocumentationRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
